
import React from "react";
import { i18nManager } from "../../../../i18n";
import { Siren } from "../../../shared/ConfirmDialog";
import LoadingGif from "../../../../assets/images/loading_circle.gif";
import { BaseService, IMember, IProfileWebsite, MemberService, SanitizedResponse } from "../../../../services";
import PageDesign from "../../../page_design/PageDesign";

export interface DesignProps {
    profile: IMember;
}

function Design(props: DesignProps) {

    const memberService = MemberService.getInstance();
    const labels = i18nManager.Labels.account.profile_website.design;
    const [profileWebsite, setProfileWebsite] = React.useState<IProfileWebsite>();

    React.useEffect(() => {
        memberService.getProfileWebsite().then(({ sanitized }: SanitizedResponse<IProfileWebsite>) => {
            setProfileWebsite(sanitized);
        }).catch(BaseService.reportError);
    }, []);

    return (<div className="account-setting">
        <div className="header">
            <span className="title">{i18nManager.Labels.account.profile_website.title} - {labels.title}</span>
        </div>
        {!profileWebsite
            ? (<div style={{ margin: "90px 110px" }}>
                <img alt={"loading"} src={LoadingGif} style={{ width: 80, margin: "auto" }} />
            </div>)
            : (<div className="profile-settings"><PageDesign designType="member" activeDesign={profileWebsite.design_settings} publicId={props.profile.username} onUpdate={updateProfileWebsite} planLevel={BaseService.getPlanCode(props.profile.plan)} /></div>)}
    </div>);

    function updateProfileWebsite(pageDesign: any, onDone?: () => void) {
        if (!profileWebsite) return onDone?.();
        profileWebsite.design_settings = pageDesign;
        memberService.updateProfileWebsite({ ...profileWebsite}).then(({ sanitized }: SanitizedResponse<IProfileWebsite>) => {
            setProfileWebsite(sanitized);
            Siren.alert(i18nManager.Labels.account.profile_website.update_successful);
        }).catch(BaseService.reportError).finally(onDone);
    }

}

export default Design;
